import React, { useContext } from 'react'
import RevenueGraph from '../DashnoardComponents/DashboardGraph/RevenueGraph'
import { Grid } from '@mui/joy'
import ManagerDashboardCard from './ManagerDashboardComponents/ManagerDashboardCard/ManagerDashboardCard'
import StatusCard from './ManagerDashboardComponents/StatusCard/StatusCard'
import { LiaToolsSolid } from "react-icons/lia";
import { RiGroupLine } from "react-icons/ri";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import './ManagerDashboardStyle.css'
import { IoWalletOutline } from "react-icons/io5";
import UserStatusList from './ManagerDashboardComponents/UserStatusList/UserStatusList'
import ScheduleInfoCard from './ManagerDashboardComponents/ScheduleInfoCard/ScheduleInfoCard'
import { FaTools, FaHammer, FaCalendarAlt, FaClock, FaUser } from 'react-icons/fa';
import { dashboardContext } from '../Dashboard'
import CustomSkelton from '../../../Components/Skeletons/CustomSkelton'
import TextSkeleton from '../../../Components/Skeletons/TextSkeleton'
import { getPercent } from '../../../utils/getPercent'
import { Card } from 'react-bootstrap'
import ScheduleOverview from '../SupervisorDashboard/SupervisorDashboardComponents/ScheduleOverview/ScheduleOverview'
import { Box } from '@mui/material'
import ScheduleStatus from '../DashnoardComponents/ScheduleStatus/ScheduleStatus'
import DashboardStatusGrid from '../DashnoardComponents/DashboardStatusGrid/DashboardStatusGrid'
import DashboardLeaveReq from '../DashnoardComponents/DashboardLeaveReq/DashboardLeaveReq'
import RevenueStatistics from '../DashnoardComponents/DashboardGraph/RevenueStatistics'

const cards = [
    {
        title: 'Total Worksites',
        key: 'WorksitesCount',
        icon: <FaTools />,
        color1: '#567C09',
        color2: '#567C09',
    },
    {
        title: 'Ongoing Projects',
        key: 'projectCount',
        icon: <FaHammer />,
        color1: '#006CB8',
        color2: '#006CB8',
    },
    {
        title: 'Schedules',
        key: 'activescheduleCount',
        icon: <FaCalendarAlt />,
        color1: '#A67DFF',
        color2: '#A67DFF',
    },
    {
        title: 'Total Equipments',
        key: 'totalEquipmentscounts',
        icon: <FaClock />,
        color1: '#3E9BFB',
        color2: '#3E9BFB',
    },
    {
        title: 'Total Employees',
        key: 'EmployeeCount',
        icon: <FaUser />,
        color1: '#3D93AB',
        color2: '#3D93AB',
    },
];

function ManagerDashboard() {

    const { data, isLoading } = useContext(dashboardContext);

    //----------------------INVOCIE PERCENTAGE CALCULATEION START------------
    const paid = data?.paidInvoices || 0;
    const unpaid = data?.unpaidInvoices || 0;
    const total = paid + unpaid;


    const paidPercent = getPercent(paid, total);
    const unpaidPercent = getPercent(unpaid, total);
    //----------------------INVOCIE PERCENTAGE CALCULATEION END------------

    //----------------------Employee Status PERCENTAGE CALCULATEION START------------
    const siteFse = data?.onsiteEngineers || 0;
    const leaveFse = data?.leaveEngineers || 0;
    const totalFse = data?.employeeCount || 0;
    const availableFse = data?.availableEngineersCount || 0

    //----------------------Employee Status PERCENTAGE CALCULATEION END------------

    //---------------------- Equipment Status Percentage Calculation ----------------------

    const ActiveEquipment = data?.ActiveEquipment || 0;
    const InactiveEquipment = data?.InactiveEquipment || 0;
    const onsiteEquipments = data?.onsiteEquipments || 0;
    const totalEquipment = data?.equipmentsCount || 0


    const OnsiteEquipmentsPercent = getPercent(onsiteEquipments, ActiveEquipment)
    const ActiveEquipmentPercent = getPercent(ActiveEquipment, totalEquipment);
    const InactiveEquipmentPercent = getPercent(InactiveEquipment, totalEquipment);

    //---------------------- End Equipment Status Percentage Calculation ----------------------

    const columnStyle = { display: 'flex', gap: '20px', marginBottom: '20px', padding: '10px', width: '100%' };
    const renderSkeletonCard = () => (
        <div style={columnStyle}>
            <CustomSkelton
                variant="rounded"
                height={140}
                width={`100%`}
                animation="wave"
                style={{ borderRadius: '12px', marginRight: '20px' }}
            />
        </div>
    );
    return (
        <>
            <div className="dashboard-header">{isLoading ? <TextSkeleton width='15%' fontSize='3rem' /> : `Dashboard`}</div>
            <div className="manager_dc_main_container">

                {isLoading ? (
                    <>
                        <CustomSkelton
                            height={140}
                            width={'100%'}
                        />
                        <CustomSkelton
                            height={140}
                            width={'100%'}
                        />
                        <CustomSkelton
                            height={140}
                            width={'100%'}
                        />
                        <CustomSkelton
                            height={140}
                            width={'100%'}
                        />
                        <CustomSkelton
                            height={140}
                            width={'100%'}
                        />
                    </>
                ) : (
                    <>
                        {cards?.map((card, index) => (
                            <ManagerDashboardCard
                                key={index}
                                title={card.title}
                                count={data?.[card.key] ?? 'N/A'}
                                subTitle={''}
                                icon={card.icon}
                                color1={card.color1}
                                color2={card.color2}
                            />
                        ))}
                    </>
                )}
            </div>

            <DashboardStatusGrid />

            {/* <div className="dashGrid_mainWrapper">
                <ScheduleStatus />
                {isLoading ? (
                    <CustomSkelton variant="rectangular" height={320} />
                ) : (
                    <DashboardLeaveReq title="Recent Leaves" />
                )}

            </div> */}

        </>
    )
}

export default ManagerDashboard